import './pages.css';



const UserSurveyPageLeft = ({ sites, isLoading, onSelectSite, selectedSite, isMobile = false, hidden = false, loadError, onRetry }) => {
    

    const filteredSites = (sites || []).filter((s) => {
  // 서버에서 깔끔하게 내려오면 이 불린값을 최우선 사용
        if (typeof s.has_survey === 'boolean') return s.has_survey;

        // 일반적인 대체 판단 로직
        const title = s.survey_title ?? s.title ?? '';
        if (title === '(제목 없음)') return false;

        // 질문 목록이나 survey_id가 있으면 등록된 것으로 판단
        if (Array.isArray(s.questions) && s.questions.length > 0) return true;
        if (s.survey_id) return true;

        // 아무 단서도 없으면 제목 유무로 보수적으로 판단
        return Boolean(title && title.trim());
    });
    
    
    return (
        <div className="left-section" hidden={hidden}>
            <h2 className="center-title">공공 모바일 UI/UX 국민평가</h2>
            {loadError && <div role="alert">{loadError} <button onClick={onRetry}>다시 시도</button></div>}
            {isMobile ? (
                <div className="mobile-site-list">
                    <p className="mobile-list-description">평가할 사이트를 확인하고 설문을 시작해주세요.</p>
                    {isLoading && !filteredSites.length && <p role="status">사이트를 불러오는 중입니다.</p>}
                    {!isLoading && !loadError && !filteredSites.length && <p>배정된 설문이 없습니다.</p>}
                    {filteredSites.map(site => (
                        <article className="mobile-site-card" key={site.survey_id}>
                            <div className="mobile-site-card-heading">
                                <h3>{site.survey_title || site.site_name}</h3>
                                <span className={`mobile-site-status ${site.status === '완료' ? 'complete' : ''}`}>{site.status || '미완료'}</span>
                            </div>
                            {site.site_name && site.site_name !== site.survey_title && <p>{site.site_name}</p>}
                            <div className="mobile-site-actions">
                                {site.url && <a className="survey-secondary" href={/^https?:\/\//i.test(site.url.trim()) ? site.url.trim() : `https://${site.url.trim()}`} target="_blank" rel="noopener noreferrer">사이트 열기 ↗</a>}
                                <button className="survey-primary" onClick={() => onSelectSite(site)}>
                                    {site.status === '완료' ? '답변 보기' : site.status === '진행중' || selectedSite?.survey_id === site.survey_id ? '설문 이어하기' : '설문 시작'}
                                </button>
                            </div>
                        </article>
                    ))}
                </div>
            ) : <div className="table-container">
                <table className="styled-table">
                    <thead>
                        <tr>
                            <th>순번</th>
                            <th>사이트명</th>
                            <th>사이트 이동</th>
                            <th>완료여부</th>
                            <th>설문하기</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="5">불러오는 중...</td></tr>
                        ) : (
                            filteredSites.map((site, index) => (
                                <tr
                                key={index}
                                className={selectedSite?.survey_id === site.survey_id ? 'selected-row' : ''}
                                >
                                <td>{index + 1}</td>
                                <td>{site.survey_title || '(제목 없음)'}</td>
                                

                                {/* ⬇ 추가된 이동 버튼 */}
                                <td>
                                    <button className='site-label'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const url = (site.url || '').trim();
                                        if (!url) return;
                                        const href = /^https?:\/\//i.test(url) ? url : `http://${url}`;
                                        window.open(href, '_blank', 'noopener,noreferrer');
                                    }}
                                    disabled={!site?.url}
                                    title={site?.url ? site.url : 'URL 미등록'}
                                    >
                                    이동
                                    </button>
                                </td>
                                <td>
                                    <span className={`status-label ${
                                    site.status === '완료' ? 'status-complete' :
                                    site.status === '진행중' ? 'status-inprogress' :
                                    'status-pending'
                                    }`}>
                                    {site.status || '미완료'}
                                    </span>
                                </td>
                                <td>
                                    <button className="user-button" onClick={() => onSelectSite(site)}>
                                    📖
                                    </button>
                                </td>
                                </tr>

                            ))
                        )}
                    </tbody>
                </table>
            </div>}
        </div>
    );
};

export default UserSurveyPageLeft;
